"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var React = _interopRequireWildcard(require("react"));

var _reactPopper = require("react-popper");

var _Box = _interopRequireDefault(require("../../Layout/Box"));

var _keyboard = require("../../utilities/keyboard");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var Popover = function Popover(_a) {
  var _b = _a.arrow,
      arrow = _b === void 0 ? false : _b,
      children = _a.children,
      clickContent = _a.clickContent,
      _c = _a.closeOnClickOutside,
      closeOnClickOutside = _c === void 0 ? true : _c,
      _d = _a.closeOnEsc,
      closeOnEsc = _d === void 0 ? true : _d,
      isOpen = _a.isOpen,
      onClose = _a.onClose,
      onOpen = _a.onOpen,
      _e = _a.placement,
      placement = _e === void 0 ? 'bottom' : _e,
      _f = _a.placementContainerClassName,
      placementContainerClassName = _f === void 0 ? 'popover-container' : _f,
      width = _a.width;

  var _g = React.useState(null),
      referenceElement = _g[0],
      setReferenceElement = _g[1];

  var _h = React.useState(null),
      popperElement = _h[0],
      setPopperElement = _h[1];

  var _j = React.useState(null),
      arrowElement = _j[0],
      setArrowElement = _j[1];

  var _k = (0, _reactPopper.usePopper)(referenceElement, popperElement, {
    placement: placement,
    modifiers: [{
      name: 'arrow',
      options: {
        element: arrowElement
      }
    }]
  }),
      styles = _k.styles,
      attributes = _k.attributes;

  var contentRef = React.useRef(null);
  var isEscapePressed = (0, _keyboard.useButtonKeys)().isEscapePressed;

  if (isEscapePressed && closeOnEsc && isOpen) {
    onClose();
  }

  var handleOnTargetClick = function handleOnTargetClick() {
    return isOpen ? onClose() : onOpen();
  };

  var handleClickOutsidePopper = function handleClickOutsidePopper(_a) {
    var target = _a.target;

    if (!isOpen) {
      return;
    }

    if (isOpen && closeOnClickOutside && contentRef.current && contentRef.current.contains(target) === false) {
      return onClose();
    }
  };

  React.useEffect(function () {
    document.addEventListener('click', handleClickOutsidePopper);
    return function () {
      return document.removeEventListener('click', handleClickOutsidePopper);
    };
  }, [handleClickOutsidePopper]);
  return React.createElement(_Box.default, {
    className: placementContainerClassName
  }, React.createElement(_Box.default, {
    as: "button",
    onClick: handleOnTargetClick,
    ref: setReferenceElement,
    type: "button",
    sx: {
      backgroundColor: 'transparent',
      border: 'none',
      padding: '0',
      width: '100%',
      margin: '0',
      display: 'block',
      '&:hover': {
        backgroundColor: 'none'
      },
      '&:focus': {
        border: 'none'
      }
    }
  }, clickContent), isOpen && React.createElement(_Box.default, (0, _tslib.__assign)({
    ref: setPopperElement,
    style: (0, _tslib.__assign)((0, _tslib.__assign)({}, styles.popper), {
      width: width,
      'z-index': '200'
    })
  }, attributes.popper), React.createElement("div", {
    ref: contentRef
  }, children, arrow && React.createElement("span", {
    ref: setArrowElement,
    style: styles.arrow
  }))));
};

var _default = Popover;
exports.default = _default;